import React, { useState, useContext } from "react"
import { css } from "@emotion/core"
import LightBox from "components/UI/LightBox"
import t from "theme"
import ColumnTitle from "components/UI/ColumnTitle"
import GoogleButton from "react-google-button"
import BeatLoader from "react-spinners/BeatLoader"
import AuthFunction from "components/Auth/AuthFunction"
import PasswordlessBox from "components/Auth/PasswordlessBox"
import Divider from "components/UI/Divider"
import FirebaseContext from "components/Common/FirebaseContext"

const AuthScreen = ({ mode, toggleComponent, ...props }) => {
    const [loading, setLoading] = useState(false)
    const firebase = useContext(FirebaseContext)
    const messages =
        mode === "signin"
            ? {
                  title: "SIGN IN",
                  emailbutton: "SEND LOGIN LINK",
                  googlebutton: "Sign in with Google",
              }
            : {
                  title: "JOIN DISRUPTION RESEARCH",
                  emailbutton: "SEND SIGN UP LINK",
                  googlebutton: "Sign up with Google",
              }

    function SignIn(provider) {
        setLoading(true)
        AuthFunction({ firebase: firebase, command: "signin", provider: provider })
    }

    return (
        <LightBox toggleComponent={toggleComponent} {...props}>
            <ColumnTitle>{messages.title}</ColumnTitle>

            <div
                css={css`
                    display: ${loading ? "none" : "flex"};
                    flex-direction: column;
                    align-items: center;
                    margin: 0 auto;
                `}>
                <PasswordlessBox buttonText={messages.emailbutton} />

                <Divider size="13rem" space={t.space[4]} color={t.color.subtlegrey} />

                <GoogleButton type="light" label={messages.googlebutton} onClick={() => SignIn("google")} />
            </div>
            <div
                css={css`
                    width: ${t.space[10]};
                    height: 100%;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                `}>
                <BeatLoader loading={loading} size={30} color={t.color.subtlegrey} />
            </div>
        </LightBox>
    )
}
export default AuthScreen
/*

//seems to go into infinite loop when click button despite actually having cookie?


PROBLEM: this only works when the component being rendered is stateful. If it's stateless, then it won't render even after Firebase is initialized.



    const uiConfig = {
        // Popup signin flow rather than redirect flow.
        signInFlow: "redirect",
        // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
        signInSuccessUrl: callback,
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
        // We will display Google and Facebook as auth providers.
        signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID, firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    }

<div>{firebase.auth().currentUser ? "Current User Is " + firebase.auth().currentUser.email : null}</div>

<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />*/
